import { useEffect, useState } from "react";

import { GenericModal } from "../../GenericModal/GenericModal";
import { RoleGuard } from "../../RoleGuard/RoleGuard";
import { useUser } from "../../../hooks/useUser";
import { DataTable } from "../../DataTable";
import { delay, Message } from "../../../utils";
import { DeliverDataColums } from "../../../constants";
import { roleConfig } from "../../../constants/roleConfig";
import { CreateDeliverModal, EditDeliverModal, ResetPasswordModal } from "../";
import { OrderSheet } from "../../DeliverInfo/DeliverSheet/OrderSheet/OrderSheet";

import { getCompanies } from "../../../service/api/Company/apiCompany";
import { createDeliver, deleteDeliver, resetPassword } from "../../../service/api/Deliver/apiDeliver";
import { getOrders, updateOrderDeliver } from "../../../service/api/Order/apiOrder";
import { ensureExistsDeliveryRecord } from "../../../service/api/DeliveryRecord/apiDeliveryRecord";
import { getAddressOptions } from "../../../service/api/AddressOptions/apiDeliver";

const DeliverSheet = ({ data }) => {
    const { companyId, role, id } = useUser();
    const [deliversData, setDeliversData] = useState([]);
    const [addressOptions, setAddressOptions] = useState([]);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [editDeliver, setEditDeliver] = useState(false);
    const [specifyMode, setSpecifyMode] = useState(false);
    const [ordersData, setOrdersData] = useState([]);
    const [deliveryDate, setDeliveryDate] = useState('');
    const [selectedDeliver, setSelectedDeliver] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [mode, setMode] = useState(companyId ? 'company' : 'personal');
    const [isResetPasswordOpen, setIsResetPasswordOpen] = useState(false);
    const [resetPasswordDeliver, setResetPasswordDeliver] = useState(null);
    const [routeData, setRouteData] = useState({
        mapUrl: '',
        drivingKm: 0,
        longDrivingKm: 0,
        drivingTime: 0,
        orderId: [],
        weight: 0,
        carbonReduction: 0
    });

    useEffect(() => {
        if (data) {
            console.log(data);
            setDeliversData(data);
        }
    }, [data]);

    useEffect(() => {
        if (!editDeliver && !isCreateOpen) return;
        let query = {};
        if (role < roleConfig['財務'] && mode === 'company' && companyId) {
            query.id = companyId;
        }
        getCompanies(query)
            .then(response => {
                if (response?.status === 200 && response.data?.result) {
                    setCompanies(response.data.result);
                }
            })
            .catch(e => console.error('查詢公司失敗:', e));
    }, [editDeliver, isCreateOpen]);

    useEffect(() => {
        if (!specifyMode) return;
        getOrders()
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setOrdersData(response.data.result);
                }
            });

        getAddressOptions()
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setAddressOptions(response.data.result);
                }
            });
    }, [specifyMode]);

    // 根據模式過濾司機資料
    const filteredDeliversData = deliversData.filter(item => {
        if (mode === 'personal') {
            return !item.company; // 個人模式：company 為空
        } else {
            return item.company; // 公司模式：company 有值
        }
    });

    const allColumns = [
        {
            name: "選擇司機",
            cell: (row) => (
                <label className="small-btn">
                    {
                        row.status === 1 &&
                        <input
                            type="radio"
                            name="deliver" // 同組 radio 需要相同 name
                            checked={selectedDeliver?.deliverId === row.id}
                            onChange={() => setSelectedDeliver({ deliverId: row.id, deliverName: row.name })}
                        />
                    }
                </label>
            ),
            key: "radio"
        },
        ...DeliverDataColums,
        {
            name: "操作",
            cell: row =>
                <div className="row-actions">
                    {
                        (role === roleConfig['員工'] && id === row.id) || (role === roleConfig['主管'] && companyId ? row.companyId === companyId : row.id === id) || (role > roleConfig['主管'] && row.role <= role) ?
                            <button className="btn btn-action--primary btn-action--sm"
                                onClick={() => setEditDeliver(row)} >編輯
                            </button>
                            : null
                    }
                    {
                        // 自己可重設密碼、role > 管理者 的人可無限制重設
                        ((id === row.id || role >= roleConfig['管理者']) && row.role <= role) ?
                            <>
                                <button className="btn btn-action--warning btn-action--sm"
                                    onClick={() => { setResetPasswordDeliver(row); setIsResetPasswordOpen(true); }} >重設密碼
                                </button>
                                <RoleGuard requiredRole={roleConfig['管理者']}>
                                    <button className="btn btn-action--danger btn-action--sm"
                                        onClick={() => handleDeletedDeliver(row)} >刪除
                                    </button>
                                </RoleGuard>
                            </>
                            : null
                    }
                </div>,
            key: "action"
        }
    ];

    // 根據模式過濾列
    const filteredAllColumns = allColumns.filter(col => !col.mode || col.mode === mode);

    const handleAddDeliver = async (newDeliver) => {
        console.log(newDeliver)
        const response = await createDeliver(newDeliver);

        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            await delay(1);
            console.log(response.status);
            setIsCreateOpen(false);
            setDeliversData(prev => [...prev, response.data.result]);
        } else {
            Message(response.data.message, 'warning');
        }
    };

    const handleDeletedDeliver = async (newDeliver) => {
        const confirmAction = window.confirm("確定要刪除此員工嗎？\n(過去被指派的訂單司機名稱不會刪除)");
        if (!confirmAction) return;
        console.log(newDeliver)
        const response = await deleteDeliver(newDeliver);

        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            await delay(1);
            console.log(response.status);
            setDeliversData(prev => prev.filter(item => item.id !== newDeliver.id));
        }
        else {
            Message(response.data.message, 'warning');
        }
    };

    const handleSpecifyDeliver = async () => {
        if (selectedDeliver === null) {
            Message('請選擇指派司機', 'warning')
            return;
        } else if (selectedRows.length === 0) {
            Message('請選擇訂單', 'warning')
            return;
        } else if (routeData.mapUrl === '' || !routeData.mapUrl) {
            Message('請制定最佳化路線', 'warning')
            return;
        } else if (deliveryDate === '') {
            Message('請選擇指派日期', 'warning')
            return;
        } else {
            const confirmAction = window.confirm('確定要指派訂單嗎?');
            if (!confirmAction) return;
            const data = {
                deliverId: selectedDeliver.deliverId,
                deliverName: selectedDeliver.deliverName,
                deliveryDate: deliveryDate,
                ...routeData,
            };
            console.log(data)
            const response = await ensureExistsDeliveryRecord(data);
            if (response.status === 200 && response.data.status === 1) {
                console.log(response.status);
                console.log(response.data);

                const response_t = await updateOrderDeliver(data);
                if (response_t.status === 200 && response_t.data.status === 1) {
                    Message(response.data.message);
                    await delay(1);
                    console.log(response_t.status);
                    window.location.reload();
                } else {
                    Message(response.data.message, 'warning');
                }
            } else {
                Message(response.data.message, 'warning');
            }
        }
    };

    const handleResetPassword = async ({ newPassword, verifyCode, phone }) => {
        if (!resetPasswordDeliver) return;

        const confirmAction = window.confirm(`確定要重設 ${resetPasswordDeliver.name} 的密碼嗎？`);
        if (!confirmAction) return;

        try {
            const response = await resetPassword({
                employeeId: resetPasswordDeliver.id,
                newPassword: newPassword,
                verifyCode: verifyCode,
                phone: phone
            });

            if (response.status === 200 && response.data.status === 1) {
                Message(response.data.message);
                setIsResetPasswordOpen(false);
                setResetPasswordDeliver(null);
            } else {
                Message(response.data.message || '重設密碼失敗', 'warning');
            }
        } catch (error) {
            console.error('Reset password error:', error);
            Message('重設密碼失敗', 'warning');
        }
    };

    return (
        <>
            <GenericModal isOpen={isCreateOpen}>
                <CreateDeliverModal
                    onSubmit={handleAddDeliver}
                    onCancel={() => setIsCreateOpen(false)}
                    companies={companies}
                    mode={mode}
                />
            </GenericModal>
            <GenericModal isOpen={editDeliver}>
                <EditDeliverModal
                    deliver={editDeliver}
                    setDeliversData={setDeliversData}
                    onClose={() => setEditDeliver(false)}
                    companies={companies}
                    mode={mode}
                />
            </GenericModal>
            <GenericModal isOpen={isResetPasswordOpen}>
                <ResetPasswordModal
                    deliver={resetPasswordDeliver}
                    onSubmit={handleResetPassword}
                    onCancel={() => setIsResetPasswordOpen(false)}
                />
            </GenericModal>
            <div className="card-header d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-2 gap-md-0">
                <div className="d-flex align-items-center">
                    <h6 className="m-0 fw-bold text-primary">
                        <i className="fas fa-table me-2"></i>司機
                    </h6>
                </div>
                <div className="sheet-actions">
                    <button
                        onClick={() => setMode(mode === 'personal' ? 'company' : 'personal')}
                        disabled={role < roleConfig['財務']}
                        className={`btn btn-action--sm ${mode === 'personal' ? 'btn-action--primary btn-action--soft' : 'btn-action--confirm btn-action--soft'
                            }`}
                        title={role < roleConfig['財務'] ? '該帳號無法切換模式' : ''}
                    >
                        {mode === 'personal' ? '👤 當前個人模式' : '🏢 當前公司模式'}
                    </button>
                    <RoleGuard requiredRole={roleConfig['主管']}>
                        <button
                            onClick={() => setIsCreateOpen(true)}
                            className="btn btn-action--confirm"
                        >
                            <i className="fas fa-plus me-2 "></i>新增司機
                        </button>
                    </RoleGuard>
                </div>
            </div>
            <div className="card-body border-top sheet-toolbar"></div>
            <DataTable
                columns={filteredAllColumns}
                data={filteredDeliversData}
                pagination
                noDataComponent="無此司機資訊"
                paginationComponentOptions={{
                    rowsPerPageText: '每頁筆數',
                    rangeSeparatorText: '總共',
                }} />

            <RoleGuard requiredRole={roleConfig['維護者']}>
                <button
                    onClick={() => setSpecifyMode((prev) => !prev)}
                    className="btn btn-action--confirm"
                >
                    <i className={`fas ${specifyMode ? 'fa-minus' : 'fa-plus'} me-2 `}></i>訂單指派
                </button>
            </RoleGuard>

            {
                specifyMode &&
                <>
                    <OrderSheet
                        data={ordersData}
                        setOrdersData={setOrdersData}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        deliveryDate={deliveryDate}
                        setDeliveryDate={setDeliveryDate}
                        routeData={routeData}
                        setRouteData={setRouteData}
                        addressOptions={addressOptions} />
                    <button
                        className="btn btn-action--primary btn-action--soft"
                        onClick={handleSpecifyDeliver}
                    >
                        <i className="fas fa-download me-2"></i> 確定指派
                    </button>
                </>
            }

        </>
    );
};

export { DeliverSheet };
